import fetch from '@/plugin/axios'

// Prompt category apis
export function addPromptCategory (data) {
  return fetch({
    url: '/api/common/prompt/category',
    method: 'Post',
    data
  })
}

export function updatePromptCategory (id, data) {
  return fetch({
    url: `/api/common/prompt/category/${id}`,
    method: 'Put',
    data
  })
}

export function removePromptCategory (id) {
  return fetch({
    url: `/api/common/prompt/category/${id}`,
    method: 'Delete'
  })
}

export function getPromptCategoryList () {
  return fetch({
    url: '/api/common/prompt/category/list',
    method: 'Get'
  })
}

// Prompt template apis
export function addPromptTemplate (data) {
  return fetch({
    url: '/api/common/prompt/template',
    method: 'Post',
    data
  })
}

export function updatePromptTemplate (id, data) {
  return fetch({
    url: `/api/common/prompt/template/${id}`,
    method: 'Put',
    data
  })
}

export function removePromptTemplate (id) {
  return fetch({
    url: `/api/common/prompt/template/${id}`,
    method: 'Delete'
  })
}

export function getPromptTemplateList (categoryId) {
  return fetch({
    url: '/api/common/prompt/template/list',
    method: 'Get',
    params: { categoryId }
  })
}

// Prompt chip apis
export function getPromptChipList (params) {
  return fetch({
    url: '/api/common/prompt/chip/list',
    method: 'Get',
    params
  })
}

export function getPromptChipDetail (id) {
  return fetch({
    url: `/api/common/prompt/chip/${id}`,
    method: 'Get'
  })
}

export function addPromptChip (data) {
  return fetch({
    url: '/api/common/prompt/chip',
    method: 'Post',
    data
  })
}

export function updatePromptChip (id, data) {
  return fetch({
    url: `/api/common/prompt/chip/${id}`,
    method: 'Put',
    data
  })
}

export function removePromptChip (id) {
  return fetch({
    url: `/api/common/prompt/chip/${id}`,
    method: 'Delete'
  })
}

export function updatePromptChipStatus (id, status) {
  return fetch({
    url: `/api/common/prompt/chip/${id}/status`,
    method: 'Put',
    params: { status }
  })
}

export function testResolveChip (text) {
  return fetch({
    url: '/api/common/prompt/chip/test/resolve',
    method: 'Post',
    data: text,
    headers: { 'Content-Type': 'text/plain' }
  })
}
